//--- TikTok埋め込みスニペット ---

(function () {
  const TIKTOK_USER = "daily_muscle";
  const PROFILE_URL = `https://www.tiktok.com/@${TIKTOK_USER}`;

  // guideLinks直後に挿入
  function insertAfter(targetEl, newEl) {
    targetEl.parentNode.insertBefore(newEl, targetEl.nextSibling);
  }

  // ラッパー作成
  function buildTikTokCard() {
    const wrap = document.createElement('div');
    wrap.className = 'embed-card embed-tiktok';
    wrap.innerHTML = `
      <div class="embed-title">
        <svg class="brand-icon brand-icon--tiktok" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path fill="currentColor" d="M15.2 2h-2.8v11.1a3.5 3.5 0 1 1-3.5-3.5c.3 0 .7.1 1 .2V7.8c-.3 0-.7-.1-1-.1A6.2 6.2 0 1 0 15.2 14V8.2c1 .9 2.3 1.6 3.7 1.8V7.1a5.9 5.9 0 0 1-3.7-1.3A5.9 5.9 0 0 1 15.2 2z"/>
        </svg>
        <span class="brand-label">TikTok</span>
      </div>
      <blockquote class="tiktok-embed"
                  cite="${PROFILE_URL}"
                  data-unique-id="${TIKTOK_USER}"
                  data-embed-type="creator"
                  style="max-width:605px; min-width:220px; margin:0;">
        <section><a href="${PROFILE_URL}?refer=creator_embed">@${TIKTOK_USER}</a></section>
      </blockquote>
    `;
    return wrap;
  }

  // スクリプトを一度だけ読み込み
  function loadScriptOnce(src, id) {
    return new Promise((res, rej) => {
      if (id && document.getElementById(id)) return res();
      if ([...document.scripts].some(s => s.src.includes(src))) return res();
      const s = document.createElement('script');
      s.id = id; s.async = true; s.src = src;
      s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  function init() {
    const secondary = document.querySelector('.secondaryContents');
    if (!secondary) return;
    const guide = secondary.querySelector('.guideLinks');
    if (!guide) return;

    // 重複防止
    if (secondary.querySelector('.embed-tiktok')) return;

    const card = buildTikTokCard();
    insertAfter(guide, card);

    loadScriptOnce('https://www.tiktok.com/embed.js', 'tiktok-embed-js')
      .catch(e => console.error('TikTok embed load error:', e));
  }

  // 表示領域に入ったら遅延初期化（不要なら init() を直接呼ぶ）
  function lazyInit() {
    const secondary = document.querySelector('.secondaryContents');
    if (!secondary) return init();
    if (!('IntersectionObserver' in window)) return init();
    const io = new IntersectionObserver((entries, obs) => {
      if (entries.some(e => e.isIntersecting)) { init(); obs.disconnect(); }
    }, { threshold: 0.05 });
    io.observe(secondary);
  }

  (document.readyState === 'loading')
    ? document.addEventListener('DOMContentLoaded', lazyInit)
    : lazyInit();
})();


//--- Instagram埋め込みスニペット ---

/**
 * ▼使い方
 * 1) IG_POST_URLS に埋め込みたい投稿/リールのURLを入れる
 *    例: https://www.instagram.com/p/xxxx/, https://www.instagram.com/reel/xxxx/
 * 2) このスニペットを既存のTikTok IIFEの後ろに貼る
 */
(function () {
  // ① 埋め込むInstagram投稿URLの配列（必要に応じて編集）
  const IG_POST_URLS = [
    'https://www.instagram.com/p/DOBFafWEoo5/'
  ];

  if (!IG_POST_URLS.length) return; // 投稿が無ければ何もしない

  // ② ユーティリティ：スクリプトを一度だけ読み込み
  function loadScriptOnce(src, id) {
    return new Promise((res, rej) => {
      if (id && document.getElementById(id)) return res();
      if ([...document.scripts].some(s => s.src.includes(src))) return res();
      const s = document.createElement('script');
      s.id = id; s.async = true; s.src = src;
      s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  // ③ InstagramカードのDOMを作成
  function buildInstagramCard() {
    const wrap = document.createElement('div');
    wrap.className = 'embed-card embed-instagram';
    wrap.innerHTML = `
      <div class="embed-title">
        <svg class="brand-icon brand-icon--instagram" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <!-- 外枠（角丸） -->
          <path fill="currentColor" d="M7 2h10a5 5 0 0 1 5 5v10a5 5 0 0 1-5 5H7a5 5 0 0 1-5-5V7a5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H7z"/>
          <!-- レンズ（中央円） -->
          <path fill="currentColor" d="M12 7.5a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9zm0 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"/>
          <!-- フラッシュ点 -->
          <circle cx="17.5" cy="6.5" r="1.2" fill="currentColor"/>
        </svg>
        <span class="brand-label">Instagram</span>
      </div>
      <div class="ig-list"></div>
    `;

    const list = wrap.querySelector('.ig-list');
    IG_POST_URLS.forEach(url => {
      const bq = document.createElement('blockquote');
      bq.className = 'instagram-media';
      bq.style.maxWidth = '100%';
      bq.style.minWidth = '0';
      bq.style.margin = '0';
      bq.setAttribute('data-instgrm-permalink', url);
      bq.setAttribute('data-instgrm-version', '14');
      list.appendChild(bq);
    });

    if (!document.getElementById('ig-embed-fix-style')) {
      const st = document.createElement('style');
      st.id = 'ig-embed-fix-style';
      st.textContent = `
        .embed-instagram { overflow: hidden; }
        .embed-instagram .instagram-media { max-width:100% !important; width:100% !important; margin:0 !important; }
        .embed-instagram iframe { max-width:100% !important; width:100% !important; display:block; margin:0 !important; }
      `;
      document.head.appendChild(st);
    }
    return wrap;
  }

  // ④ TikTokカードの直後にInstagramカードを挿入
  function insertBelowTikTok(instaCard) {
    const tiktokCard = document.querySelector('.embed-tiktok');
    if (!tiktokCard) return false;
    tiktokCard.parentNode.insertBefore(instaCard, tiktokCard.nextSibling);
    return true;
  }

  // ⑤ レイジー初期化（TikTokが描画され次第、直下に追加）
  function init() {
    const instaCard = buildInstagramCard();
    const placed = insertBelowTikTok(instaCard);
    if (!placed) return; // TikTokがまだ無ければ何もしない（下のMOで拾う）

    // Instagram公式embed.jsを読み込み → 描画実行
    loadScriptOnce('https://www.instagram.com/embed.js', 'ig-embed-js')
      .then(() => {
        // window.instgrm は embed.js 読み込みで生える
        if (window.instgrm && window.instgrm.Embeds && window.instgrm.Embeds.process) {
          window.instgrm.Embeds.process();
        }
      })
      .catch(e => console.error('Instagram embed load error:', e));
  }

  // ⑥ TikTokカード出現を監視してから配置（TikTok IIFEの後処理と整合）
  const mo = new MutationObserver(() => {
    if (document.querySelector('.embed-instagram')) return; // 二重生成防止
    if (document.querySelector('.embed-tiktok')) {
      init();
    }
  });
  mo.observe(document.body, { childList: true, subtree: true });

  // 保険：ロード完了/リサイズ時にiFrame幅を再調整
  function fitInstagram() {
    document.querySelectorAll('.embed-instagram iframe[src*="instagram.com"]').forEach(ifr => {
      ifr.style.maxWidth = '100%';
      ifr.style.width = '100%';
      ifr.style.margin = '0';
    });
  }
  window.addEventListener('load', fitInstagram);
  window.addEventListener('resize', fitInstagram);
})();

// --- 余白ゼロで収める：実測フィット版 ---
(function () {
  const MIN = 326; // Instagramの最小幅

  function tightenIg() {
    document.querySelectorAll('.embed-instagram .instagram-media').forEach(host => {
      const wrap = host.parentElement;                 // .ig-list の直下のラッパー
      const w = wrap.clientWidth || host.offsetWidth || MIN;
      const scale = Math.min(1, w / MIN);

      // 幅が足りないときだけ縮小、十分あれば等倍
      host.style.transformOrigin = 'top left';
      host.style.transform = `scale(${scale})`;

      // 実際のiframe高さを取得 → ラッパー高さに反映（= 余白ゼロ）
      const ifr = host.querySelector('iframe');
      const baseH = (ifr && ifr.offsetHeight) || host.offsetHeight || 700;
      wrap.style.height = Math.round(baseH * scale) + 'px';
      wrap.style.overflow = 'hidden';
    });
  }

  // 画面サイズ変化でも追従
  window.addEventListener('resize', tightenIg);
  window.addEventListener('load', tightenIg);

  // Instagramの描画や高さ変化を監視（実測で更新）
  const mo = new MutationObserver(tightenIg);
  mo.observe(document.body, { childList: true, subtree: true });

  // 生成された iframe のサイズ変化も拾う
  const ro = new ResizeObserver(tightenIg);
  const observeIframes = () => {
    document
      .querySelectorAll('.embed-instagram .instagram-media iframe')
      .forEach(el => ro.observe(el));
  };
  observeIframes();
  // 後から増えた場合にも
  const mo2 = new MutationObserver(observeIframes);
  mo2.observe(document.body, { childList: true, subtree: true });
})();
